
export default {
  "hero.title": "Industrial Knitting",
  "hero.subtitle": "ーWeaving the Future, Spinning Valueー",
  "hero.description": "A revolutionary technology that weaves functionality into products. Discover a new era of manufacturing that transcends traditional painting and exterior materials.",
  "hero.cta": "Learn More",
  
  "about.title": "Our Vision",
  "about.subtitle": "Industrial Knit Opens New Horizons in Design and Functionality",
  "about.description": "Nichinan Corporation has been operating as a comprehensive development support company with industrial prototype models as our main business. As a new challenge, we established the apparel brand 【ritsu】 in 2022. We propose boho-chic and romantic items by fusing Nichinan's technical expertise cultivated through \"manufacturing\" with designer creativity.",
  
  "portfolio.title": "Use Case",
  "portfolio.subtitle": "Infinite Possibilities of Industrial Knitting",
  "portfolio.description": "In traditional product design, it was common to create expressions through painting and exterior materials. However, Industrial Knitting overturns this conventional wisdom. The new concept of \"products wearing clothes.\" It is a solution that realizes diversity unattainable through previous expressions, by \"knitting in\" functions without painting and flexibly changing forms according to custom designs and applications.",
  
  "services.title": "Technology",
  "services.subtitle": "Leveraging cutting-edge technology and extensive experience to elevate your business to the next level",
  "services.item1.title": "Paint-Free Design",
  "services.item1.description": "Environmentally friendly manufacturing that eliminates painting processes",
  "services.item2.title": "Functional Integration",
  "services.item2.description": "Weaving multiple functions into a single material",
  "services.item3.title": "Custom Flexibility",
  "services.item3.description": "Flexible response to diverse designs and applications",
  
  "core.title": "Core Technology",
  "core.subtitle": "Innovation Born from the Fusion of Tradition and Technology",
  "core.item1.title": "3D Knitting Technology",
  "core.item1.description": "Advanced technology that creates three-dimensional shapes through knitting",
  "core.item2.title": "Material Development",
  "core.item2.description": "Development of new materials combining functionality and design",
  "core.item3.title": "Digital Design",
  "core.item3.description": "Precision design using the latest CAD/CAM systems",
  
  "contact.title": "Contact Us",
  "contact.subtitle": "Please feel free to contact us for project consultations and quotations",
  "contact.name": "Name",
  "contact.email": "Email",
  "contact.message": "Message",
  "contact.send": "Send",
  "contact.success": "Your message has been sent successfully!",
  "contactAddress": "Address",
  "contactAddressValue": "〒252-1125 1-14-13 Yoshioka-Higashi, Ayase City, Kanagawa Prefecture",
  "contact.contactInfo": "Contact Information",
  "contact.address": "Address",
  "contact.phone": "Phone",
  "contact.emailLabel": "Email",
  "contact.businessHours": "Business Hours",
  "contact.businessHoursDetail": "Weekdays 8:30 - 17:30",
  "contact.businessHoursClosed": "(Closed on weekends and holidays)",
  "contact.phoneNumber": "0467-78-8891 (Main)",
  "contact.step": "Step",
  "contact.basicInfo": "Basic Information",
  "contact.namePlaceholder": "Taro Yamada",
  "contact.emailPlaceholder": "example@email.com",
  "contact.company": "Company Name",
  "contact.companyPlaceholder": "Sample Corporation",
  "contact.next": "Next",
  "contact.back": "Back",
  "contact.serviceInterest": "Service of Interest",
  "contact.serviceInterestDesc": "Please select the applicable service",
  "contact.service1": "Sample Material Production",
  "contact.service2": "Design Prototyping",
  "contact.service3": "Design Consulting",
  "contact.service4": "Product Planning/Development",
  "contact.service5": "Other",
  "contact.projectScale": "Project Scale",
  "contact.projectScaleDesc": "Please select the expected project scale",
  "contact.scale1": "Small (1-2 months)",
  "contact.scale2": "Medium (3-6 months)",
  "contact.scale3": "Large (6+ months)",
  "contact.scale4": "Undecided / Want to discuss",
  "contact.startTiming": "Desired Start Timing",
  "contact.startTimingDesc": "Please select the project start timing",
  "contact.timing1": "Start immediately",
  "contact.timing2": "Within 1 month",
  "contact.timing3": "Within 2-3 months",
  "contact.timing4": "After 3 months",
  "contact.timing5": "Undecided / Want to discuss",
  "contact.budget": "Budget Range",
  "contact.budgetDesc": "Please select your expected budget",
  "contact.budget1": "Less than ¥500,000",
  "contact.budget2": "¥500,000 - ¥1,000,000",
  "contact.budget3": "¥1,000,000 - ¥3,000,000",
  "contact.budget4": "Over ¥3,000,000",
  "contact.budget5": "Undecided / Want to discuss",
  "contact.detailMessage": "Detailed Message (Optional)",
  "contact.detailMessageDesc": "Please provide any additional information you would like to share",
  "contact.messagePlaceholder": "Please share project details or questions",
  "contact.characters": " characters",
  "contact.toConfirm": "To Confirmation",
  "contact.confirmInput": "Confirm Input",
  "contact.edit": "Edit",
  "contact.sending": "Sending...",
  "contact.submitSuccess": "Submission Complete",
  "contact.submitSuccessMessage": "Thank you for your inquiry.\\nOur representative will contact you shortly.",
  "contact.newInquiry": "New Inquiry",
  "contact.submitError": "Submission Failed",
  "contact.submitErrorMessage": "Please try again or contact us by phone.",
  
  "footer.rights": "All rights reserved.",
  "footer.link": "Website Builder",
  "footer.companyName": "Nichinan Corporation",
  "footer.companyDescription": "Creating the future of manufacturing with innovative knitting technology.",
  "footer.servicesTitle": "Services",
  "footer.service1": "Industrial Knit",
  "footer.service2": "Apparel Brand【ritsu】",
  "footer.service3": "Design Development",
  "footer.service4": "Various Prototyping",
  "footer.companyInfoTitle": "Company Information",
  "footer.companyNameLabel": "Company Name: Nichinan Corporation",
  "footer.postalCode": "〒252-1125",
  "footer.address": "1-14-13 Yoshioka-Higashi, Ayase City, Kanagawa Prefecture",
  "footer.tel": "TEL: 0467-78-8891",
  "footer.fax": "FAX: 0467-78-8895",
  "footer.copyright": "© 2024 Nichinan Corporation. All rights reserved.",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.termsOfService": "Terms of Service",
  
  "coreTech.title": "Core Technology",
  "Industrial Knit – Design Woven with Intelligence1": "Industrial Knit –",
  "Industrial Knit – Design Woven with Intelligence2": "Design Woven with Intelligence",
  "coreTech.tagline1": "ー Weaving Sensibility,",
  "coreTech.tagline2": "Designing Functionality ー",
  "coreTech.paragraph1": "Building on the expertise we developed in industrial product development support, we ventured into the new field of apparel in 2022.",
  "coreTech.paragraph2": "Through the process of designing, manufacturing, and selling clothing ourselves, we discovered a \"new method of expression\" born from the fusion of materials and structure. Through our experience with accessory design using full-color 3D printing and the flexible, three-dimensional expression of knitting, we created \"Industrial Knit,\" a new solution that combines functionality with sculptural beauty.",
  "coreTech.paragraph3": "A completely new creative solution that fuses the sensibility of apparel with the precision of industrial design.",
  "coreTech.companyDescription": "Nichinan Co., Ltd., as a comprehensive development support company, has long specialized in industrial prototype modeling. In 2022, we took on a new challenge by establishing our own apparel brand 【ritsu】 By combining Nichinan's advanced manufacturing expertise with the creativity of our designers, we present boho-chic and romantic items that embody the spirit of craftsmanship and innovation.",
  "coreTech.viewDetails": "View Details",
  
  aboutTitle: 'Our Vision',
  aboutSubtitle: 'Industrial Knit Opens New Horizons in Design and Functionality',
  aboutCompanyDescription: 'Nichinan Co., Ltd., as a comprehensive development support company, has long specialized in industrial prototype modeling. In 2022, we took on a new challenge by establishing our own apparel brand 【ritsu】 By combining Nichinan\'s advanced manufacturing expertise with the creativity of our designers, we present boho-chic and romantic items that embody the spirit of craftsmanship and innovation.',
  aboutViewDetails: 'View Details',
  
  'aboutStory.description': 'From the era of decorating with paint to the era of wearing knitted fabrics. Industrial Knitting creates new diversity that transcends the limits of expression with the concept of "products wearing clothes."',
  'aboutStory.item1.title': 'Changeable Products, Changing Moods',
  'aboutStory.item1.description': 'This is not just about reducing inventory. The traditional ritual (temple) of the region grows into a postwar, beautiful pasta (ingredient) of life, a gentle transformation of the world.',
  'aboutStory.item2.title': 'Function × Design × Sustainability',
  'aboutStory.item2.description': 'Industrial Knit weaves functionality into the material itself, integrating design repeatedly. By "knitting" instead of combining complex alternatives and parts through intricate processes, we achieve both foundation and high strength/constant temperature. This realizes alternatives and parts combined through complex processes, achieving both innovation and innovation.',
  'aboutStory.item3.title': 'Diverse Application Areas Across Industries',
  'aboutStory.item3.description': 'This technology is not limited to apparel. Expansion is progressing into diverse fields such as architecture, business, medical, robotics, and product design',
  
  'portfolio.item1.title': 'Automotive',
  'portfolio.item1.subtitle': 'Fabric with woven sensors, light-transmitting fabric, and instrumental panels that beautifully display projection mapping',
  'portfolio.item1.tag1': 'Spatial Design',
  'portfolio.item1.tag2': 'Smart Fabric',
  'portfolio.item1.tag3': 'Interactive',
  'portfolio.item1.description': 'Innovative spatial design utilizing industrial knitting technology. We provide new design solutions that overturn conventional spatial concepts, including smart fabrics with woven sensors, special knit materials that transmit light, and instrumental panels optimized for projection mapping.',
  'portfolio.item1.feature1': 'Development of smart fabrics with embedded sensors',
  'portfolio.item1.feature2': 'Lighting system using light-transmitting knit materials',
  'portfolio.item1.feature3': 'Panel design compatible with projection mapping',
  'portfolio.item1.feature4': 'Creation of interactive spatial experiences',
  'portfolio.item1.feature5': 'Dynamic design change function according to environment',
  'portfolio.item1.result1': 'Improved spatial comfort and sensory value',
  'portfolio.item1.result2': 'Expansion of expressive freedom through technology',
  'portfolio.item1.result3': 'Creation of interactive experiences connecting people and spaces',
  'portfolio.item1.result4': 'Flexible design evolution harmonizing function and form',
  'portfolio.item1.result5': 'New value creation through sustainable material concepts',
  
  'portfolio.item2.title': 'Product',
  'portfolio.item2.subtitle': 'Product design wearing knit clothing. Transition from traditional hard shells to soft skins',
  'portfolio.item2.tag1': 'Product Design',
  'portfolio.item2.tag2': 'Knit Skin',
  'portfolio.item2.tag3': 'Sustainable',
  'portfolio.item2.description': 'An innovative design approach where products "wear clothes." A new product design solution that simultaneously improves tactile sensation, design quality, and environmental performance by replacing traditional hard plastic shells and metal casings with functional and beautiful knit skins.',
  'portfolio.item2.feature1': 'Realization of soft tactile sensation through knit skin',
  'portfolio.item2.feature2': 'Paint-free color variation support',
  'portfolio.item2.feature3': 'Customizable texture design',
  'portfolio.item2.feature4': 'Balance of weight reduction and durability',
  'portfolio.item2.feature5': 'Recyclable material composition',
  'portfolio.item2.result1': 'Design expression giving products vitality and personality',
  'portfolio.item2.result2': 'Enhanced experiential value through tactile sensation and warmth from materials',
  'portfolio.item2.result3': 'New form of interior connecting products and spaces',
  'portfolio.item2.result4': 'Product experience that deepens attachment and stimulates sensibility',
  'portfolio.item2.result5': 'Sustainable next-generation manufacturing model',
  
  'portfolio.item3.title': 'Interior',
  'portfolio.item3.subtitle': 'Refresh your mood by changing everything from planters to lighting and sofas!',
  'portfolio.item3.tag1': 'Interior Design',
  'portfolio.item3.tag2': 'Knit Cover',
  'portfolio.item3.tag3': 'Refresh',
  'portfolio.item3.description': 'Introducing the new concept of "changing clothes" to interior spaces. An innovative interior solution where all interior items such as planters, lighting fixtures, and sofas can wear knit "clothes," allowing you to freely change the expression of your space according to seasons and moods.',
  'portfolio.item3.feature1': 'Knit cover system for planters',
  'portfolio.item3.feature2': 'Changeable knit shades for lighting fixtures',
  'portfolio.item3.feature3': 'Custom knit covers for sofas and chairs',
  'portfolio.item3.feature4': 'Texture and color changes according to seasons',
  'portfolio.item3.feature5': 'Removable functional knit decorations',
  'portfolio.item3.result1': 'Flexibility to freely change spatial impressions',
  'portfolio.item3.result2': 'Comfortable experiential value through warmth and tactile sensation',
  'portfolio.item3.result3': 'Providing seasonal enjoyment',
  'portfolio.item3.result4': 'Sustainable lifestyle proposals',
  'portfolio.item3.result5': 'New form of interior connecting products and spaces',
  
  'portfolio.item4.title': 'Robotics',
  'portfolio.item4.subtitle': 'Knit skin for robots. Transformation from mechanical appearance to friendly presence',
  'portfolio.item4.tag1': 'Robotics',
  'portfolio.item4.tag2': 'Knit Skin',
  'portfolio.item4.tag3': 'Human-Friendly',
  'portfolio.item4.description': 'As an innovative approach in the robotics field, we transform robots with traditionally cold and mechanical appearances into more friendly and warm presences for humans by dressing them in "knit skin." A next-generation robot design solution that balances functionality with emotional affinity.',
  'portfolio.item4.feature1': 'Knit skin cover system for robots',
  'portfolio.item4.feature2': 'Affinity enhancement function through tactile sensation',
  'portfolio.item4.feature3': 'Expressive texture design',
  'portfolio.item4.feature4': 'Attachment/detachment system considering maintainability',
  'portfolio.item4.feature5': 'Skin change function according to environment',
  'portfolio.item4.result1': 'Improved user affinity',
  'portfolio.item4.result2': 'Enhanced robot acceptance',
  'portfolio.item4.result3': 'Improved safety perception',
  'portfolio.item4.result4': 'Improved maintenance efficiency',
  'portfolio.item4.result5': 'On-demand production support',
  
  'portfolio.item5.title': 'Wearable',
  'portfolio.item5.subtitle': 'Revolutionizing medical experiences from wearable devices to medical equipment with knit skin that stays close to people',
  'portfolio.item5.tag1': 'Health Tech',
  'portfolio.item5.tag2': 'Wearable',
  'portfolio.item5.tag3': 'Medical',
  'portfolio.item5.description': 'It has the potential to build a new social infrastructure as a wearable data platform. This is not merely an evolution of clothing, but possesses value as a "second skin" that directly connects human biometric information and sensibility.',
  'portfolio.item5.feature1': 'Knit skin covers for wearable devices',
  'portfolio.item5.feature2': 'Knitting of patient contact surfaces of medical devices',
  'portfolio.item5.feature3': 'Medical fabrics with woven antibacterial and deodorizing functions',
  'portfolio.item5.feature4': 'Smart knit materials with embedded biosensors',
  'portfolio.item5.feature5': 'Design to reduce psychological burden on patients',
  'portfolio.item5.result1': 'Integration performance for sensors and other components',
  'portfolio.item5.result2': 'Fusion of function and design',
  'portfolio.item5.result3': 'Optimization of wearable wearing performance',
  'portfolio.item5.result4': 'Expanded design freedom',
  'portfolio.item5.result5': 'Improved wearability',
  
  'portfolio.item6.title': 'Health Tech',
  'portfolio.item6.subtitle': 'Applying innovative knitting technology to medical devices such as supporters and corsets',
  'portfolio.item6.tag1': 'Medical',
  'portfolio.item6.tag2': 'Supporter',
  'portfolio.item6.tag3': 'Rehabilitation',
  'portfolio.item6.description': 'Revolutionizing traditional hard and uncomfortable medical supporters and corsets with industrial knitting technology. We are developing next-generation medical devices that significantly improve patient comfort while reliably providing necessary medical effects.',
  'portfolio.item6.feature1': 'Custom-made supporters using 3p knitting',
  'portfolio.item6.feature2': 'Corsets with woven graduated compression function',
  'portfolio.item6.feature3': 'Medical knits balancing breathability and heat retention',
  'portfolio.item6.feature4': 'Rehabilitation progress monitoring with embedded sensors',
  'portfolio.item6.feature5': 'Washable and hygienic medical textiles',
  'portfolio.item6.result1': 'Improved patient wearing comfort',
  'portfolio.item6.result2': 'Improved sustainability of treatment effects',
  'portfolio.item6.result3': 'Medical cost reduction effects',
  'portfolio.item6.result4': 'Improved rehabilitation continuation rate',
  'portfolio.item6.result5': 'Reduced burden on medical staff',
  
  'portfolio.modal.projectImages': 'Project Images',
  'portfolio.modal.projectOverview': 'Project Overview',
  'portfolio.modal.mainFeatures': 'Main Features',
  'portfolio.modal.technologies': 'Technologies Used',
  'portfolio.modal.results': 'Results & Effects',
  'portfolio.modal.close': 'Close',
  'portfolio.modal.imageEditor': 'Image Editor',
  'portfolio.modal.adjustments': 'Adjustments',
  'portfolio.modal.brightness': 'Brightness',
  'portfolio.modal.contrast': 'Contrast',
  'portfolio.modal.saturation': 'Saturation',
  'portfolio.modal.rotation': 'Rotation',
  'portfolio.modal.scale': 'Scale',
  'portfolio.modal.quickAdjust': 'Quick Adjust',
  'portfolio.modal.rotateLeft': 'Rotate Left',
  'portfolio.modal.rotateRight': 'Rotate Right',
  'portfolio.modal.zoomIn': 'Zoom In',
  'portfolio.modal.zoomOut': 'Zoom Out',
  'portfolio.modal.reset': 'Reset',
  'portfolio.modal.save': 'Save',
  
  'services.innovation.title': 'Innovation',
  'services.innovation.description': 'AI learns and expands the knowledge and sensibility cultivated by craftsmen over many years. The workflow created together by humans and AI generates source code in real-time from natural language and instantly builds knitting data. By fusing the precision of craftsmen\'s handwork with the speed of AI, colors, three-dimensional structures, and functions freely intersect, expanding unprecedented possibilities of expression. This is the future workflow born from the resonance of craftsmanship and technology.',
  'services.designTeam.title': 'Design Team',
  'services.designTeam.description': 'Cross-functional team: Designers, modelers, and knitting experts come together as one team, learning the fundamentals of knitting and integrating with manufacturing techniques cultivated through years of trial and error. The creativity and technology cultivated in this process have merged to create a new concept: Industrial Knit.',
  'services.viewDetails': 'View Details',
  'services.service1.link': 'Workflow',
  'services.service2.link': 'Creative Team',
};
